import { Home, Gavel, KeyRound, Users, Infinity as InfinityIcon, BadgeCheck } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";

const BENEFITS = [
  { icon: Home, text: "Your home and property are protected from judgment creditors and lawsuits." },
  { icon: Gavel, text: "Bypasses probate completely. Your family will never be stuck in court for months or years." },
  { icon: KeyRound, text: "Assets are controlled by YOU. Not banks not courts not the government." },
  { icon: Users, text: "Generational wealth transfers smoothly to your children and grandchildren." },
  { icon: InfinityIcon, text: "Works while you are alive AND after. Unlike a will which only activates at death." },
  { icon: BadgeCheck, text: "Every file reviewed through veteran military legal benefits." },
];

export const TrustBank = () => (
  <section className="bg-inkdeep py-24 sm:py-36 relative overflow-hidden" data-testid="trust-bank-section">
    <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, #C9A23C 1px, transparent 0)", backgroundSize: "34px 34px" }} aria-hidden="true" />
    <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-start">
        <div className="lg:sticky lg:top-32">
          <Reveal>
            <Eyebrow>Trust as a Bank</Eyebrow>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-cream tracking-tight leading-[1.08] mt-6">
              Your Trust Is More Than a Document. <em className="text-gold italic">It Is Your Own Personal Bank.</em>
            </h2>
            <p className="text-cream/70 text-base sm:text-lg leading-relaxed mt-8">
              Most people think a trust just handles things after you are gone. That is a will. A living trust
              is different. It works for you while you are still alive.
            </p>
            <p className="text-cream/70 text-base sm:text-lg leading-relaxed mt-5">
              When set up correctly your trust becomes a structure that holds and grows your wealth, keeps it
              out of courts, shields it from lawsuits, and passes it to your family without delay. Wealthy
              families have used this for generations. Now everyday families can too.
            </p>
          </Reveal>
        </div>
        <div className="space-y-4">
          {BENEFITS.map(({ icon: Icon, text }, i) => (
            <Reveal key={i} delay={0.07 * i} y={32}>
              <div
                className="flex items-start gap-5 bg-surface/80 border border-white/8 rounded-xl px-6 py-5 hover:border-gold/40 hover:translate-x-1.5 transition-[border-color,transform] duration-400"
                data-testid={`benefit-item-${i}`}
              >
                <span className="text-gold mt-0.5 shrink-0"><Icon size={21} strokeWidth={1.9} /></span>
                <p className="text-cream/85 leading-relaxed text-sm sm:text-base">{text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
